import React from 'react';
import styled from 'styled-components'
import Popover from '@material-ui/core/Popover';
import PropTypes from 'prop-types';
import Help from '@material-ui/icons/HelpOutline';

const HelpTip = styled.span`
  color: ${props => props.theme.color.primary};
  cursor: pointer;
  display: flex;
  align-items: center;
  font-family: ${props => props.theme.font.primary};
  font-size: .9375rem !important;
  font-weight: 400 !important;
  /* margin-bottom: 16px; */
  text-decoration: none;
  svg {
    margin-right: 6px;
  }
  &:hover {
    text-decoration: underline;
  }
`;

const Message = styled.p`
  color: #595959;
  font-family: ${props => props.theme.font.primary};
  font-size: .9375rem;
  line-height: 1.25rem;
  padding: 16px;
  max-width: 600px;
`;

const HelpComponent = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  }

  const handleClose = () => {
    setAnchorEl(null);
  }

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <>
      <HelpTip onClick={handleClick}><Help />{props.label}</HelpTip>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Message>{props.message}</Message>
      </Popover>
    </>
  )
}

HelpComponent.propTypes = {
  label: PropTypes.string,
  message: PropTypes.string,
};


export default HelpComponent